import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import type {
  I18NextTranslationPaths,
  I18NextValues,
} from "@dfp/isomorphic-typed-translations";

import type translations from "./translations/en.json";

export function useCommonTranslation() {
  const { t, i18n } = useTranslation("react-common-translation");

  return useMemo(
    () => ({
      commonTT: (
        path: I18NextTranslationPaths<typeof translations>,
        values?: I18NextValues,
      ) => t(path, values),
      language: i18n.language,
    }),
    [t, i18n.language],
  );
}
